import { useNavigate } from 'react-router-dom'
import { Check, Send, Loader2, Undo2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface ApprovalDetailFooterProps {
  isPending: boolean
  isApproved: boolean
  isApproving: boolean
  isSendingBack: boolean
  isUnapproving: boolean
  isFrozen?: boolean
  onApprove: () => void
  onSendBack: () => void
  onUnapprove: () => void
}

export function ApprovalDetailFooter({
  isPending,
  isApproved,
  isApproving,
  isSendingBack,
  isUnapproving,
  isFrozen,
  onApprove,
  onSendBack,
  onUnapprove,
}: ApprovalDetailFooterProps) {
  const navigate = useNavigate()

  return (
    <div className="flex items-center justify-between bg-white border-t border-border px-8 py-4">
      <Button
        variant="outline"
        className="border-muted-foreground"
        onClick={() => navigate('/approvals')}
      >
        Back
      </Button>
      <div className="flex items-center gap-3">
        {isFrozen && (
          <span className="text-sm text-muted-foreground">
            Plan is frozen &ndash; the owner must unfreeze it before approval
            changes.
          </span>
        )}
        {isApproved ? (
          <Button
            variant="outline"
            className="border-purple-600 text-purple-600 hover:bg-purple-50 gap-2"
            disabled={isUnapproving || isFrozen}
            onClick={onUnapprove}
          >
            {isUnapproving ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <Undo2 className="h-4 w-4" />
            )}
            Unapprove
          </Button>
        ) : (
          <>
            <Button
              variant="outline"
              className="border-[#CF1F2E] text-[#CF1F2E] hover:bg-red-50 gap-2"
              disabled={!isPending || isSendingBack || isFrozen}
              onClick={onSendBack}
            >
              {isSendingBack ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <Send className="h-4 w-4" />
              )}
              Send Back to Planner
            </Button>
            <Button
              className="bg-emerald-600 hover:bg-emerald-700 text-white gap-2"
              disabled={!isPending || isApproving || isFrozen}
              onClick={onApprove}
            >
              {isApproving ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <Check className="h-4 w-4" />
              )}
              Approve Plan
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
